import React, { Fragment } from 'react';
import { TextField, Typography, MenuItem } from '@material-ui/core';
import { ISelectFilter } from './types';

/**
 * Represents a text field filter component for the lead list.
 *
 * @param {TextFieldProps} {
 *     label,
 *     value,
 *     onChange,
 * }
 */
export const SelectFilter = ({
    label,
    value,
    onChange,
    options,
    id = 'select-filter',
    ...props
}: ISelectFilter) => (
    <Fragment>
        <Typography
            variant="h6"
            data-testid="select-filter-label"
            style={{ minWidth: 85 }}
        >
            {label}
        </Typography>
        <TextField
            id={id}
            select
            fullWidth
            variant="outlined"
            size="small"
            onChange={onChange}
            value={value}
            inputProps={{
                'data-testid': 'select-filter-input',
            }}
            {...props}
        >
            {options.map((option, index) => (
                <MenuItem
                    data-testid={`select-filter-option-${option.value}`}
                    value={option.value}
                    key={index}
                >
                    {option.label}
                </MenuItem>
            ))}
        </TextField>
    </Fragment>
);
